import PropTypes from 'prop-types';

// Map a version status to its badge variant suffix + visible label.
const BADGE_BY_STATUS = {
	ACTIVE: { variant: 'active', label: 'Active' },
	DRAFT: { variant: 'draft', label: 'Draft' },
	DEPRECATED: { variant: 'deprecated', label: 'Deprecated' },
	RETIRED: { variant: 'retired', label: 'Retired' },
};

// Neutral fallback for unknown/undefined statuses.
const NEUTRAL_BADGE = { variant: 'retired', label: '—' };

// Resolve a status string to its { variant, label } badge descriptor.
export function badgeForStatus(status) {
	return BADGE_BY_STATUS[status] || NEUTRAL_BADGE;
}

// Render a colored status pill for the given version status.
export function StatusBadge({ status }) {
	const { variant, label } = badgeForStatus(status);
	return (
		<span className={`dsv-compare__badge dsv-compare__badge--${variant}`}>
			<span className="dsv-compare__badge-dot" />
			{label}
		</span>
	);
}

StatusBadge.propTypes = {
	status: PropTypes.string,
};
